module.exports = __webpack_public_path__ + "slogan-new.png?735074ebd459047320af0e7e389e11ac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan-new.png
// module id = 124
// module chunks = 0